import { createScopedDescriptor } from 'quartz/globalState/api';
export const HISTORY_INSTANCE = createScopedDescriptor('historyInstance', 'EXECUTION_CONTEXT');
export const HISTORY_BASE_PATH = createScopedDescriptor('historyBasePath', 'EXECUTION_CONTEXT');